var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKyc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_72_23445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4167 19.9085V23.7504H9.33333H0.25V19.9085C0.25 18.2493 1.34297 16.8136 2.90682 16.3721L2.90711 16.372L7.03477 15.2012H9.33333H11.633L15.7581 16.3323C17.3256 16.8133 18.4167 18.2515 18.4167 19.9085Z",
    fill: "#3CAADC",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 14.9512H9.33328H6.99995L6.22217 15.1479C6.33883 16.8004 7.66106 18.0987 9.33328 18.0987C11.0055 18.0987 12.3277 16.8004 12.4444 15.1479L11.6666 14.9512Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 12.1973H7V14.9514C7 16.2497 8.05 17.312 9.33333 17.312C10.6167 17.312 11.6667 16.2497 11.6667 14.9514V12.1973Z",
    fill: "#FCB98B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 5.36523V9.04966C13.75 11.5111 11.7592 13.521 9.33329 13.521C6.90743 13.521 4.91663 11.5111 4.91663 9.04966V5.36523H13.75Z",
    fill: "#FFD3B3",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 6.29492H14.2722C14.7389 6.29492 15.1278 6.72771 15.05 7.19984L14.8944 8.38017C14.8556 8.77361 14.5056 9.04902 14.1167 9.04902H14V6.29492Z",
    fill: "#FFD3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66665 6.29492H4.39443C3.92776 6.29492 3.53887 6.72771 3.61665 7.19984L3.7722 8.38017C3.81109 8.77361 4.16109 9.04902 4.54998 9.04902H4.66665V6.29492Z",
    fill: "#FFD3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 6.99544L13.4649 5.84178L13.4179 5.65175H13.2222H9.33329H5.4444H5.24866L5.2017 5.84178L4.91663 6.99544V4.32798C4.91663 2.29937 6.55743 0.643555 8.55551 0.643555H10.5C11.2147 0.643555 11.8055 1.23707 11.8055 1.96733V2.21733H12.0555C13.0036 2.21733 13.75 2.96822 13.75 3.93454V6.99544Z",
    fill: "#893C1A",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 0.393555H17.1111V3.5411",
    stroke: "#FC657E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66665 0.393555H1.55554V3.5411",
    stroke: "#FC657E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 14.5577H17.1111V11.4102",
    stroke: "#FC657E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66665 14.5577H1.55554V11.4102",
    stroke: "#FC657E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.16663 7.47559H17.5",
    stroke: "#FC657E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1111 23.9997C19.2588 23.9997 20.9999 22.2382 20.9999 20.0653C20.9999 17.8924 19.2588 16.1309 17.1111 16.1309C14.9633 16.1309 13.2222 17.8924 13.2222 20.0653C13.2222 22.2382 14.9633 23.9997 17.1111 23.9997Z",
    fill: "#68BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1111 23.2131C18.8293 23.2131 20.2222 21.8038 20.2222 20.0655C20.2222 18.3272 18.8293 16.918 17.1111 16.918C15.3929 16.918 14 18.3272 14 20.0655C14 21.8038 15.3929 23.2131 17.1111 23.2131Z",
    fill: "#EDEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5555 19.8689L16.7222 21.0493L18.9778 18.8066",
    stroke: "#68BE17",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_72_23445"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKyc);
export default __webpack_public_path__ + "static/media/kyc.4981df3a8ad115ea2129a3234b4a57c2.svg";
export { ForwardRef as ReactComponent };